﻿export class HandlesWindowNavigation {
  public static execute(options: Options): void {
    if (!options.url)
      return;

    let _window = (<any>window);
    if (options.target == '_self') {
      _window.location = options.url;
    }
    else if (options.target == '_blank') {
      _window.open(options.url, options.target);
    }
  }
}

interface Options {
  url: string,
  target: string,
}